const TAG_ARGUMENTS = "[object Arguments]";
const TAG_ARRAY = "[object Array]";
const TAG_ARRAY_BUFFER = "[object ArrayBuffer]";
const TAG_ASYNC_FUNCTION = "[object AsyncFunction]";
const TAG_BIGINT = "[object BigInt]";
const TAG_BOOL = "[object Boolean]";
const TAG_DATE = "[object Date]";
const TAG_ERROR = "[object Error]";
const TAG_FUNCTION = "[object Function]";
const TAG_GENERATOR = "[object Generator]";
const TAG_GENERATOR_FUNCTION = "[object GeneratorFunction]";
const TAG_GLOBAL = "[object global]";
const TAG_MAP = "[object Map]";
const TAG_NULL = "[object Null]";
const TAG_NUMBER = "[object Number]";
const TAG_OBJECT = "[object Object]";
const TAG_PROMISE = "[object Promise]";
const TAG_REGEXP = "[object RegExp]";
const TAG_SET = "[object Set]";
const TAG_SHARED_ARRAY_BUFFER = "[object SharedArrayBuffer]";
const TAG_STRING = "[object String]";
const TAG_SYMBOL = "[object Symbol]";
const TAG_VOID = "[object Undefined]";
const TAG_WEAK_MAP = "[object WeakMap]";
const TAG_WEAK_SET = "[object WeakSet]";
const TAG_WINDOW = "[object Window]";

export default {
  ARGUMENTS: TAG_ARGUMENTS,
  ARRAY: TAG_ARRAY,
  ARRAY_BUFFER: TAG_ARRAY_BUFFER,
  ASYNC_FUNCTION: TAG_ASYNC_FUNCTION,
  BIGINT: TAG_BIGINT,
  BOOL: TAG_BOOL,
  DATE: TAG_DATE,
  ERROR: TAG_ERROR,
  FUNCTION: TAG_FUNCTION,
  GENERATOR: TAG_GENERATOR,
  GENERATOR_FUNCTION: TAG_GENERATOR_FUNCTION,
  GLOBAL: TAG_GLOBAL,
  MAP: TAG_MAP,
  NULL: TAG_NULL,
  NUMBER: TAG_NUMBER,
  OBJECT: TAG_OBJECT,
  PROMISE: TAG_PROMISE,
  REGEXP: TAG_REGEXP,
  SET: TAG_SET,
  SHARED_ARRAY_BUFFER: TAG_SHARED_ARRAY_BUFFER,
  STRING: TAG_STRING,
  SYMBOL: TAG_SYMBOL,
  VOID: TAG_VOID,
  WEAK_MAP: TAG_WEAK_MAP,
  WEAK_SET: TAG_WEAK_SET,
  WINDOW: TAG_WINDOW,
};
